import { useEffect } from "react";
import { useFormContext } from "react-hook-form";

import {
  isStaleHubStationId,
  type IHubStationsContextValue,
} from "@ryde/controls";

/** Once the current pair's hubs have loaded, a hub chosen for an earlier pair is cleared so the new pair's default is picked. */
export const useClearStaleHubStation = ({
  hubFieldName,
  hubStations,
}: {
  hubFieldName: string;
  hubStations: IHubStationsContextValue;
}): void => {
  const { getValues, setValue } = useFormContext();
  const { hubStationsDropdownList, isHubStationsLoading } = hubStations;

  useEffect(() => {
    if (isHubStationsLoading) {
      return;
    }

    const isStale = isStaleHubStationId({
      hubStationId: getValues(hubFieldName),
      hubStations: hubStationsDropdownList,
    });

    if (!isStale) {
      return;
    }

    setValue(hubFieldName, null, {
      shouldDirty: true,
      shouldValidate: true,
    });
  }, [
    getValues,
    hubFieldName,
    hubStationsDropdownList,
    isHubStationsLoading,
    setValue,
  ]);
};
